import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import CalculatorResource from '@/modules/tax/resources/CalculatorResource';
import { Calculator } from '@/modules/tax/models/calculators/Calculator';
import { CalculatorCacheItem } from '@/modules/tax/models/calculators/CalculatorCacheItem';

export class CalculatorService extends BaseService {
  resource: typeof CalculatorResource;

  constructor() {
    super();
    this.resource = CalculatorResource;
  }

  calculate(params: Params = {}): Promise<Calculator> {
    return this.resource.calculate(params);
  }

  saveDataInCache(params: Params = {}): Promise<CalculatorCacheItem> {
    return this.resource.saveDataInCache(params);
  }
}

export default new CalculatorService();
